import React from 'react'
import {MBMemberInput} from '../../Atoms/MBMemberInput'
import {MBContentSubTitleTypography} from '../../Atoms/Typographies'
import {Spacer} from '../../../../Common/Components/Spacer'
import {PIMWarningMessages} from '../../Atoms/Labels/PIMWarningMessages'
import {PIMStack} from '../../Atoms/Layouts/Bases/PIMStack'
import {PIMCard} from '../../Atoms/Cards/PIMCard'
import {LinkIconText} from '../../Molecules/LinkIconText'

type Props = {
  agreedIdList: number[]
  agreeCheckErrors: string[]
  onClick: () => void
}

export function AgreementCheckBoxContentBlock(props: Props): JSX.Element {
  return (
    <PIMCard
      headerProps={{title: '利用規約同意', require: true}}
      testId={'block-agreement-check-box'}
    >
      <PIMStack spacing={'18px'}>
        <MBContentSubTitleTypography>
          下記｢利用規約｣のリンク先より最後まで内容をご確認の上、｢同意する｣ボタンを押していただくと利用規約同意にチェックされます。
        </MBContentSubTitleTypography>

        <div data-testid={'agree-checkbox'}>
          <Spacer mt={'26px'}>
            <LinkIconText
              dataTestId={'agreement-confirm-button'}
              onClick={(): void => props.onClick()}
            >
              <MBContentSubTitleTypography>利用規約</MBContentSubTitleTypography>
            </LinkIconText>
          </Spacer>

          <Spacer mt={'23px'} mb={'18px'}>
            <label>
              <MBMemberInput
                className="form-check_01"
                type="checkbox"
                disabled={true}
                checked={props.agreedIdList.length > 0}
                hasError={props.agreeCheckErrors.length > 0}
              />
              <span className="txt">利用規約を契約内容とすることに同意します。</span>
              {props.agreeCheckErrors.length > 0 && (
                <Spacer mt={'10px'}>
                  <PIMWarningMessages messages={props.agreeCheckErrors}/>
                </Spacer>
              )}
            </label>
          </Spacer>
        </div>
      </PIMStack>
    </PIMCard>
  )
}
